var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7ZM7.25085 5.16771C6.56999 5.4509 5.20925 6.03703 3.1686 6.9261C2.83724 7.05788 2.66365 7.18679 2.64785 7.31284C2.62114 7.52587 2.88791 7.60976 3.25119 7.72399C3.30061 7.73953 3.35181 7.75563 3.4043 7.77269C3.7617 7.88887 4.24248 8.02479 4.49242 8.03018C4.71913 8.03508 4.97217 7.94162 5.25154 7.74978C7.15818 6.46275 8.14239 5.81222 8.20418 5.7982C8.24777 5.7883 8.30818 5.77586 8.34911 5.81224C8.39004 5.84862 8.38602 5.91752 8.38168 5.936C8.35526 6.04866 7.30807 7.02222 6.76615 7.52604C6.59721 7.6831 6.47738 7.79451 6.45288 7.81995C6.398 7.87695 6.34207 7.93087 6.28832 7.98268C5.95628 8.30277 5.70728 8.54281 6.30211 8.93479C6.58796 9.12316 6.8167 9.27893 7.04489 9.43434C7.2941 9.60405 7.54267 9.77332 7.86427 9.98414C7.94621 10.0378 8.02447 10.0936 8.10069 10.148C8.39071 10.3547 8.65127 10.5405 8.97318 10.5109C9.16022 10.4937 9.35344 10.3178 9.45156 9.79321C9.68346 8.5535 10.1393 5.86743 10.2446 4.76057C10.2539 4.66359 10.2422 4.53948 10.2329 4.485C10.2236 4.43052 10.2041 4.3529 10.1333 4.29543C10.0494 4.22738 9.91995 4.21303 9.86205 4.21405C9.59876 4.21869 9.19482 4.35914 7.25085 5.16771Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.14adbe737998fae29a8fb515f6a0d058.svg";
export { ForwardRef as ReactComponent };